import types from './types';
import {
    fetchElementsPaginated,
    fetchElement,
    submitElement,
    deleteElement
} from './common';
import moment from 'moment';

const apiUrl = '/api/participants';

export function submitParticipant(values) {
    values.birth_date = moment(values.birth_date).format('YYYY-MM-DD');
    return submitElement(apiUrl, values, types.SUBMIT_PARTICIPANT);
}

export function fetchParticipant(itemId) {
    return fetchElement(apiUrl, itemId, types.LOAD_PARTICIPANT);
}

export function fetchParticipantsPaginated(page = 0, size = 10, queryData = {}) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.LOAD_PARTICIPANTS_PAGINATED, queryData);
}

export function fetchParticipantByUuid(participantUuid) {
    return fetchElement(`${apiUrl}/uuid`, participantUuid, types.LOAD_PARTICIPANT_BY_UUID);
}

export function initializeParticipantFormData(participant) {
    return {
        type: types.INITIALIZE_PARTICIPANT_FORM_DATA,
        payload: participant
    }
}

export function deleteParticipant(participant) {
    return deleteElement(apiUrl, participant.id, types.DELETE_PARTICIPANT);
}

export function fetchParticipantResultV2(itemId) {
    return fetchElement(`${apiUrl}/results`, itemId, types.LOAD_PARTICIPANT_RESULT_V2);
}

export function fetchParticipantResult(itemId) {
    return fetchElement('/api/participant-results', itemId, types.LOAD_PARTICIPANT_RESULT);
}

export function submitParticipantResult(values) {
    if (values.titles && typeof values.titles === 'string') {
        values.title = values.titles.split(',');
    }
    if (values.row && typeof values.row === 'string') {
        values.row = values.row.split(',');
    }
    values.birth_date = moment(values.birth_date).format('YYYY-MM-DD');

    return submitElement('/api/participant-results', values, types.SUBMIT_PARTICIPANT_RESULT);
}


export function submitParticipantResultsSearch(values) {
    if (values.birth_date) {
        values.birth_date = moment(values.birth_date).format('YYYY-MM-DD');

    }
    return submitElement(`${apiUrl}/results`, values, types.SUBMIT_PARTICIPANT_RESULT_SEARCH);
}

export function submitAdminParticipantResultsSearch(values) {
    if (values.birth_date) {
        values.birth_date = moment(values.birth_date).format('YYYY-MM-DD');
    }
    return submitElement(`${apiUrl}/results`, values, types.SUBMIT_ADMIN_PARTICIPANT_RESULT_SEARCH);
}




// WEBPACK FOOTER //
// ./src/js/actions/participant.js